import { format } from "date-fns";

export const formatUKDate = (date?: Date | null) => {
  if (!date) return "";

  return format(date, "dd.MM.yyyy");
};

export const formatYearDate = (date: Date | null) => {
  if (!date) return "";

  return format(date, "yyyy");
};

// takes a date with a timezone and strips it so date remains same
export const removeTimezoneOffset = (date: Date | null) => {
  if (!date) return null;

  return new Date(date.getTime() - date.getTimezoneOffset() * 60000);
};
